import React from 'react';

const EmptyTodos = () => {
  return <p>¡Crea tu primer tarea!</p>
}

export { EmptyTodos }
